import { gql } from '@parkchirp/api-client';

export const SAVE_CREDIT_CARD = gql`
  mutation savePaymentToken(
    $token: GPIInput!,
    $cognitoSub: String!,
    $tenantSubscriptionId: String
  ) {
      savePaymentToken(
        gpi_token: $token,
        cognitoSub: $cognitoSub,
        tenantSubscriptionId: $tenantSubscriptionId
      )
    }
`;

export const SAVE_BANK_ACCOUNT = gql`
  mutation savePaymentToken(
    $gpi_bank_account: GPIBankAccountInput!,
    $cognitoSub: String!,
    $tenantSubscriptionId: String,
    $paymentProviderId: Int!
  ) {
      savePaymentToken(
        gpi_bank_account: $gpi_bank_account,
        cognitoSub: $cognitoSub
        tenantSubscriptionId: $tenantSubscriptionId,
        paymentProviderId: $paymentProviderId
      )
    }
`;

export const DELETE_CREDIT_CARDS = gql`
  mutation deleteCreditCard(
    $cognitoSub: String!,
    $cardToken: [String]!,
    $subscriptionId: String!,
    $tenantSubscriptionId: String
    $paymentProviderId: Int!
  ) {
      deleteCreditCard(
        cognitoSub: $cognitoSub,
        cardToken: $cardToken,
        subscriptionId: $subscriptionId
        tenantSubscriptionId: $tenantSubscriptionId
        paymentProviderId:  $paymentProviderId
      )
    }
`;

export const DELETE_BANK_ACCOUNTS = gql`
  mutation deleteBankAccounts(
    $cognitoSub: String!,
    $accountTokens: [String]!,
    $subscriptionId: String!,
    $tenantSubscriptionId: String,
    $paymentProviderId: Int!
  ) {
      deleteBankAccounts(
        cognitoSub: $cognitoSub,
        accountTokens: $accountTokens,
        subscriptionId: $subscriptionId,
        tenantSubscriptionId: $tenantSubscriptionId,
        paymentProviderId: $paymentProviderId
      )
    }
`;

export const PAY_INVOICE = gql`
  mutation payInvoice(
      $invoiceId: String!,
      $paymentToken: String!,
      $paymentMethod: String!,
      $allowDuplicate: Boolean,
      $customPaymentAmount: Int,
      $tenantSubscriptionId: String
  ) {
      payInvoice(
        invoiceId: $invoiceId,
        paymentToken: $paymentToken,
        paymentMethod: $paymentMethod,
        allowDuplicate: $allowDuplicate,
        customPaymentAmount: $customPaymentAmount,
        tenantSubscriptionId: $tenantSubscriptionId
      )
    }
`;

export const PAY_INVOICE_PROCESS_PAYMENT = gql`
  mutation payInvoiceProcessPayment(
      $invoiceId: String!,
      $paymentToken: String!,
      $paymentMethod: String!,
      $allowDuplicate: Boolean,
      $customPaymentAmount: Int,
      $tenantSubscriptionId: String
  ) {
      payInvoiceProcessPayment(
        invoiceId: $invoiceId,
        paymentToken: $paymentToken,
        paymentMethod: $paymentMethod,
        allowDuplicate: $allowDuplicate,
        customPaymentAmount: $customPaymentAmount,
        tenantSubscriptionId: $tenantSubscriptionId
      )
    }
`;

export const GET_CREDIT_CARD_FEE_PRICE = gql`
  query getCreditCardFeePrice(
    $billingProfileId: String!,
    $paymentAmount: Int!,
    $numberOfInvoices: Int,
    $subscriptionId: String,
    $tenantSubscriptionId: String,
  ) {
    getCreditCardFeePrice(
        billingProfileId: $billingProfileId,
        paymentAmount: $paymentAmount,
        numberOfInvoices: $numberOfInvoices,
        subscriptionId: $subscriptionId,
        tenantSubscriptionId: $tenantSubscriptionId
    ) {
        price
        displayPrice
    }
  }
`;

export const GET_TAX_REPORT = gql`
  query getTaxReport(
    $facilityId: String!
    $accountId: String
    $subscriptionName: String
    $transactionStartDate: String
    $transactionEndDate: String
    $applicationStartDate: String
    $applicationEndDate: String
    $hideZeroDollarColumns: Boolean
  ) {
    getTaxReport(
        facilityId: $facilityId
        accountId: $accountId
        subscriptionName: $subscriptionName
        transactionStartDate: $transactionStartDate
        transactionEndDate: $transactionEndDate
        applicationStartDate: $applicationStartDate
        applicationEndDate: $applicationEndDate
        hideZeroDollarColumns: $hideZeroDollarColumns
    ) {
      url
    }
  }
`;

export const GET_USER_PAYMENT_METHODS = gql`
  query getUserPaymentMethods(
      $userId: String!
      $paymentProviderId: Int
  ) {
    getUserPaymentMethods(
        userId: $userId
        paymentProviderId: $paymentProviderId
    ) {
      gpiCards {
        token
        type
        last4
        expMonth
        expYear
        paymentProviderId
      }
      gpiBankAccounts {
        token
        accountType
        last4
        firstName
        lastName
        businessName
        paymentProviderId
      }
    }
  }
`;

export const GET_SLIDEPAY_HOSTED_FIELDS_TOKEN = gql`
    query getSlidePayHostedFieldsToken(
        $origin: String!
        $facilityId: String
        $subscriptionId: String
    ) {
        getSlidePayHostedFieldsToken(
            origin: $origin
            facilityId: $facilityId
            subscriptionId: $subscriptionId
        ) {
            hostedFieldsToken
        }
    }
`;

export const LIST_PAYMENT_LOGS = gql`
    query listPaymentLogs(
        $limit: Int
        $offset: Int
        $order: SortOrder
        $filters: [Filter]
        $subscriptionId: String
        $invoiceId: String
    ) {
        listPaymentLogs(
            limit: $limit
            offset: $offset
            order: $order
            filters: $filters
            subscriptionId: $subscriptionId
            invoiceId: $invoiceId
        ) {
            data {
                id
                invoiceId
                paymentReferenceId
                paymentMeta
                voidMeta
                paymentMethodType
                paymentStatus
                facilityName
                facilityNumber
                type
                last4
                createdAt
                updatedAt
            }
        }
    }
`;

export const LIST_ORPHAN_PAYMENT_LOGS = gql`
    query listOrphanPaymentLogs(
        $limit: Int
        $offset: Int
        $order: SortOrder
        $filters: [Filter]
    ) {
        listOrphanPaymentLogs(
            limit: $limit
            offset: $offset
            order: $order
            filters: $filters
        ) {
            data {
                id
                paymentReferenceId
                paymentMeta
                voidMeta
                paymentMethodType
                paymentStatus
                type
                last4
                createdAt
                updatedAt
            }
        }
    }
`;

export const GET_ACH_DISCOUNT_ELIGIBILITY = gql`
    query getAchDiscountEligibility(
        $subscriptionId: String!
        $invoiceIds: [String]
    ) {
        getAchDiscountEligibility(
            subscriptionId: $subscriptionId
            invoiceIds: $invoiceIds
        ) {
            isEligible
            discountPercentage
            totalDiscountAmount
        }
    }
`;

export const GET_ACH_DISCOUNT_AMOUNT = gql`
  query getAchDiscountAmount(
    $facilityId: String!
    $subscriptionId: String
    $feeAmount: Int!
    $taxAmount: Int!
  ) {
    getAchDiscountAmount(
      facilityId: $facilityId,
      subscriptionId: $subscriptionId,
      feeAmount: $feeAmount,
      taxAmount: $taxAmount,
    ) {
      discountAmount
      discountPercentage
    }
  }
`;
